export default genericCloudflareProvider(MEDIAHUB_BASE_PATH);
